<div  style="width: 100%;height: 100%;
    padding-left: 3%;padding-right: 3%;padding-top: 1%;">
    <app-dashboard-view-two [value]="value">
    
    </app-dashboard-view-two>
</div>